import { PaymentLayout } from "./_layout";

export default function PaymentCancelledPage() {
  return <PaymentLayout>Pago cancelado</PaymentLayout>;
}
